import { render } from "./n-switch.vue?vue&type=template&id=f9059516&scoped=true&ts=true"
import script from "./n-switch.vue?vue&type=script&lang=ts"
export * from "./n-switch.vue?vue&type=script&lang=ts"

import "./n-switch.vue?vue&type=style&index=0&id=f9059516&lang=scss&scoped=true"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9059516"]])

export default __exports__